"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Tab;

var _default = Tab = function () {
  var Tab =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Tab, _React$Component);

    function Tab(props) {
      var _this;

      _classCallCheck(this, Tab);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Tab).apply(this, arguments));
      _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(Tab, [{
      key: "onClick",
      value: function onClick() {
        var base;

        if (!this.props.disabled) {
          var _base;

          return typeof (base = this.props).onClick === "function" ? (_base = base).onClick.apply(_base, arguments) : void 0;
        }
      }
    }, {
      key: "render",
      value: function render() {
        return _react.default.createElement("div", {
          className: "Tab ".concat(this.props.active ? 'active' : ''),
          disabled: this.props.disabled,
          onClick: this.onClick
        }, this.props.children);
      }
    }]);

    return Tab;
  }(_react.default.Component);

  ;
  Tab.displayName = 'Tabs.Tab';
  Tab.propTypes = {
    key: _propTypes.default.string,
    active: _propTypes.default.bool,
    disabled: _propTypes.default.bool,
    onClick: _propTypes.default.func
  };
  Tab.defaultProps = {
    active: false,
    disabled: false,
    onClick: function onClick() {}
  };
  return Tab;
}.call(void 0);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/tabs/tab.js
// module id = 2215
// module chunks = 3 7 14